export default "__VITE_ASSET__Di_jd6U7__"